export const MAP_DEFAULTS = {
  viewport: {
    latitude: 40.7450,
    longitude: -123.8695,
    zoom: 8,
  }
};

export const BASEMAPS = {
  light: {
    label: 'Light',
    url: 'mapbox://styles/mapbox/light-v11'
  },
  streets: {
    label: 'Streets',
    url: 'mapbox://styles/mapbox/streets-v12'
  },
  outdoors: {
    label: 'Topographic',
    url: 'mapbox://styles/mapbox/outdoors-v12'
  },
  satellite: {
    label: 'Imagery',
    url: 'mapbox://styles/mapbox/satellite-streets-v12'
  },
  dark: {
    label: 'Dark',
    url: 'mapbox://styles/mapbox/dark-v11'
  }
};